import { createSelector } from 'reselect';

export const uiSelector = (state) => state.get('ui');

export const instancesLoadedSelector = createSelector(
  uiSelector,
  (ui) => !ui.getIn(['instances', 'loader'])
);
